export enum WizardSteps {
  BasketOverview,
  UserInfo,
  BasketValidation,
  Payment,
  PaymentStatus
}
